import React from "react";
import { motion } from "framer-motion";

import jbmGroupLogo from "@/assets/trusted/jbm_group_logo.jpeg";
import karmayogiBharatLogo from "@/assets/trusted/karmayogi_bharat_logo.jpeg";
import sparkMindaLogo from "@/assets/trusted/Spark_Minda.png";
import spectraLogo from "@/assets/trusted/spectra.jpeg";
import pwcLogo from "@/assets/trusted/pwc_logo.jpeg";

const LOGOS = [
  { key: "spectra", src: spectraLogo, alt: "Spectra" },
  { key: "spark-minda", src: sparkMindaLogo, alt: "Spark Minda" },
  {
    key: "karmayogi-bharat",
    src: karmayogiBharatLogo,
    alt: "Karmayogi Bharat",
    label: "Karmayogi Bharat",
    large: true,
  },
  { key: "jbm", src: jbmGroupLogo, alt: "JBM", large: true },
  { key: "pwc", src: pwcLogo, alt: "PwC" },
];

export default function TrustedBy() {
  return (
    <section
      data-testid="trusted-by-section"
      className="relative border-y border-slate-200/80 bg-white/60 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <motion.p
          initial={{ opacity: 0, y: 6 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.6 }}
          className="mx-auto max-w-[22rem] text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500 sm:max-w-none sm:text-[12.5px] sm:tracking-[0.2em]"
        >
          Trusted by teams modernizing training and knowledge transfer
        </motion.p>

        <div className="mt-6 grid grid-cols-2 gap-x-3 gap-y-7 place-items-center sm:mt-8 sm:grid-cols-3 sm:gap-x-4 sm:gap-y-8 lg:grid-cols-5 lg:gap-x-6">
          {LOGOS.map((logo, i) => (
            <motion.div
              key={logo.key}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className={
                logo.label
                  ? logo.large
                    ? "flex min-w-0 w-full max-w-[min(100%,17rem)] flex-col items-center justify-center gap-2 px-0.5 text-center text-slate-800 sm:flex-row sm:gap-4 sm:text-left"
                    : "flex min-w-0 w-full max-w-[min(100%,14rem)] flex-col items-center justify-center gap-2 px-0.5 text-center text-slate-800 sm:flex-row sm:gap-3 sm:text-left"
                  : logo.large
                    ? "flex h-[3.75rem] min-w-0 w-full max-w-[min(100%,11rem)] items-center justify-center sm:h-[4.85rem] sm:max-w-[13rem] lg:max-w-[14rem]"
                    : "flex h-12 min-w-0 w-full max-w-[min(100%,9rem)] items-center justify-center sm:h-16 sm:max-w-[10rem] lg:max-w-[11rem]"
              }
              data-testid={`trusted-logo-${i}`}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className={
                  logo.label
                    ? logo.large
                      ? "mx-auto h-11 w-auto max-h-[3.5rem] max-w-full shrink-0 object-contain object-center sm:h-14 sm:max-h-[5rem] lg:max-h-[5.25rem]"
                      : "mx-auto h-10 w-auto max-h-12 max-w-full shrink-0 object-contain object-center sm:h-11 sm:max-h-[3.25rem]"
                    : logo.large
                      ? "mx-auto h-full w-auto max-h-[3.75rem] max-w-full object-contain object-center sm:max-h-[4.85rem] lg:max-h-[5.5rem]"
                      : "mx-auto h-full w-auto max-h-12 max-w-full object-contain object-center xs:max-h-14"
                }
                loading="lazy"
                decoding="async"
              />
              {logo.label ? (
                <span className="max-w-[min(100%,13rem)] text-[12px] font-bold leading-snug tracking-tight text-balance sm:max-w-[11rem] sm:text-[13px] sm:leading-tight md:text-[15.5px] lg:text-[16.5px]">
                  {logo.label}
                </span>
              ) : null}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
